import React from 'react';

import { Modal, Row, Col } from 'react-bootstrap';

import cx from 'classnames';

import AvatarEditor from 'react-avatar-editor';
import Button from 'src/legacy/components/Button';

import styles from './styles.module.scss';

class ImageEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,
      allowZoomOut: true,
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
      borderRadius: this.props.borderRadius,
      preview: null,
      width: this.props.weight,
      height: this.props.height
    }

    this.onResetClick = this.onResetClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show != this.props.show) {
      this.setState({ show: nextProps.show });
    }
  }

  onResetClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  onUploadClick = () => {
    const img = this.editor.getImage().toDataURL();
    this.props.onChange(img);
  }


  handleScale = e => {
    const scale = parseFloat(e.target.value)
    this.setState({ scale })
  }

  handleAllowZoomOut = ({ target: { checked: allowZoomOut } }) => {
    this.setState({ allowZoomOut })
  }

  rotateLeft = e => {
    e.preventDefault()

    this.setState({
      rotate: this.state.rotate - 90
    })
  }

  rotateRight = e => {
    e.preventDefault()
    this.setState({
      rotate: this.state.rotate + 90
    })
  }

  handleBorderRadius = e => {
    const borderRadius = parseInt(e.target.value)
    this.setState({ borderRadius })
  }

  handleXPosition = e => {
    const x = parseFloat(e.target.value)
    this.setState({ position: { ...this.state.position, x } })
  }

  handleYPosition = e => {
    const y = parseFloat(e.target.value)
    this.setState({ position: { ...this.state.position, y } })
  }

  handleWidth = e => {
    const width = parseInt(e.target.value)
    this.setState({ width })
  }

  handleHeight = e => {
    const height = parseInt(e.target.value)
    this.setState({ height })
  }

  logCallback(e) {
    console.log('callback', e)
  }

  setEditorRef = editor => {
    if (editor) this.editor = editor
  }

  handlePositionChange = position => {
    this.setState({ position })
  }

  render() {
    return (
      <Modal show={this.state.show} keyboard={true}
        backdrop={true} dialogClassName={cx(styles.dialog, this.props.className)}>

        <Modal.Body className={styles.modalBody}>
          <div className={cx(styles.editor, this.props.className)}>
            <AvatarEditor
              ref={this.setEditorRef}
              scale={parseFloat(this.state.scale)}
              width={this.props.width}
              height={this.props.height}
              position={this.state.position}
              onPositionChange={this.handlePositionChange}
              rotate={parseFloat(this.state.rotate)}
              borderRadius={this.props.borderRadius}
              border={this.props.border}
              onSave={this.handleSave}
              onLoadFailure={this.logCallback.bind(this, 'onLoadFailed')}
              onLoadSuccess={this.logCallback.bind(this, 'onLoadSuccess')}
              onImageReady={this.logCallback.bind(this, 'onImageReady')}
              onImageLoad={this.logCallback.bind(this, 'onImageLoad')}
              onDropFile={this.logCallback.bind(this, 'onDropFile')}
              image={this.props.image}
              crossOrigin={`anonymous`}
            />

            <div className={styles.zoomSlider}>
              <input
                name='scale'
                type='range'
                onChange={this.handleScale}
                min={this.state.allowZoomOut ? '0.01' : '1'}
                max='4'
                step='0.01'
                defaultValue='1' />
            </div>
            <Button.Tray className={styles.buttonTray}>
              <Button
                primary
                title='Upload'
                className={styles.buttonUpload}
                onClick={this.onUploadClick}>
              </Button>
              <Button
                title='Cancel'
                className={styles.buttonReset}
                onClick={this.onResetClick}>
              </Button>
            </Button.Tray>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ImageEditor;